import { ProgressBar } from "react-bootstrap";

type Props = {
  actualPoints: number;
  maxPoints: number;
};
export default function ProgressBarScore({ actualPoints, maxPoints }: Props) {
  const progressBarConfig = getProgressBarConfig(actualPoints, maxPoints);

  return (
    <div>
      <span style={{ display: "flex", justifyContent: "center" }}>
        <span className="tx-18">
          {actualPoints}/<span className="tx-13">{maxPoints}</span>
        </span>
      </span>
      <ProgressBar
        variant={progressBarConfig.variant}
        now={progressBarConfig.percent}
        style={{
          borderRadius: 5,
          width: 100,
          opacity: 0.5,
          backgroundColor: "#999999",
        }}
      />
    </div>
  );
}

type ProgressVariant = "danger" | "warning" | "success";
type ProgressBarConfig = {
  variant: ProgressVariant;
  percent: number;
};
function getProgressBarConfig(
  actualPoints: number,
  maxPoints: number
): ProgressBarConfig {
  const percent = (actualPoints / maxPoints) * 100;
  let variant: ProgressVariant = "warning";

  if (percent > 60) {
    variant = "success";
  } else if (percent < 40) {
    variant = "danger";
  }

  return {
    percent,
    variant,
  };
}
